import React, { useRef } from 'react';
import { motion } from 'framer-motion';

// Simple fallback component instead of using Three.js
const TokenAnimation: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  
  // Create floating tokens
  const tokens = Array.from({ length: 20 }).map((_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * 30 + 20,
    duration: Math.random() * 20 + 10,
    delay: Math.random() * 5,
    type: Math.random() > 0.5 ? 'fttf' : 'dusd'
  }));

  return (
    <div 
      ref={containerRef}
      className="fixed inset-0 overflow-hidden pointer-events-none z-0"
      style={{ 
        background: 'radial-gradient(circle at 50% 50%, rgba(138, 43, 226, 0.05), transparent 70%)'
      }}
    >
      {tokens.map(token => (
        <motion.div
          key={token.id}
          className={`absolute rounded-full ${
            token.type === 'fttf' 
              ? 'bg-gradient-to-br from-primary-500/20 to-primary-700/20 text-primary-500/70' 
              : 'bg-gradient-to-br from-primary-500/20 to-primary-700/20 text-primary-500/70'
          }`}
          style={{
            left: `${token.x}%`,
            top: `${token.y}%`,
            width: token.size,
            height: token.size,
            fontSize: token.size * 0.4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: token.type === 'fttf' 
              ? '0 0 15px rgba(138, 43, 226, 0.2)' 
              : '0 0 15px rgba(56, 189, 248, 0.2)',
          }}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ 
            opacity: [0, 0.7, 0.5, 0.7, 0],
            scale: [0, 1, 0.8, 1, 0],
            x: [0, Math.random() * 100 - 50, Math.random() * 100 - 50, 0],
            y: [0, Math.random() * 100 - 50, Math.random() * 100 - 50, -100],
            rotate: [0, Math.random() * 360, Math.random() * -360, 0]
          }}
          transition={{ 
            duration: token.duration,
            delay: token.delay,
            repeat: Infinity,
            repeatDelay: Math.random() * 5
          }}
        >
          {token.type === 'fttf' ? 'F' : '$'}
        </motion.div>
      ))}
    </div>
  );
};

export default TokenAnimation;